/**
 * Whether a resolved role set is a DENIED account (ACOP-140).
 *
 * `determineRoles` collapses every denial — Suspended, Rejected, Expired, an unset status — to the
 * `guest` tier (plus `employee` for a denied employee). Sign-in already refuses these accounts
 * (copilot-api verifyEmail.ts); this is the backstop for one that is somehow signed in anyway, which
 * gets a dead-end screen with no menu and no access.
 *
 * Fails OPEN on purpose in exactly one direction: roles that are missing, empty or malformed mean
 * "not resolved yet", not "denied" — a failed role refresh must not lock a good user out of the app.
 * The real boundary is server-side either way (copilot-api's tier floor, AVS OS scoping).
 */
export function isDeniedRoles(roles: unknown): boolean {
  if (!Array.isArray(roles) || roles.length === 0) return false;
  const hasTier = roles.some((r) => r === "pending" || r === "standard" || r === "support");
  return !hasTier && roles.includes("guest");
}
